function placeholderLabels() {
    var inputs = document.querySelectorAll(
        ".FormWrap .middleColumn input, .FormWrap .middleColumn textarea"
    );
    Array.prototype.forEach.call(inputs, function (input) {
        input.placeholder = input.labels.length
            ? input.labels[0].textContent.trim()
            : "";
    });
}

export default {
    init: function () {
        placeholderLabels();
    }
};
